import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const WorldNews = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.worldNews.title')}
      contentType="worldNews"
      description={t('page.worldNews.desc')}
      outputLabel={t('page.worldNews.output')}
      showDurationSelector
      programMode
    />
  );
};
